import Vue from 'vue'
import axios from 'axios';

Vue.prototype.$assuntos = async () =>{
  try { 
    let res = await axios.get('assuntos/todos',{});
    return res.data;
  } catch (e) {
    throw e;
  }  
}

Vue.prototype.$secretaria = async () =>{
  try { 
    let res = await axios.get('secretaria/todos',{});
    return res.data;
  } catch (e) {
    throw e;
  }  
}

Vue.prototype.$assuntosAvan = async () =>{
  try { 
    let res = await axios.get('assuntos/a/todos',{});
    return res.data;
  } catch (e) {
    throw e;
  }  
}

Vue.prototype.$secretariaAvan = async () =>{
  try { 
    let res = await axios.get('secretaria/a/todos',{});
    return res.data;
  } catch (e) {
    throw e;
  }  
}

//editar secretaria exibição ao publico
Vue.prototype.$secretariaEditPublico = async (id,valor) => {
  try {
    let res = await axios.put('secretaria/a/editar/'+id, {
      exibir_ao_publico: valor
    });
    //console.log("aqui!"+ valor);
  } catch (e) {
    throw e;
  }
}

//editar secretaria status
Vue.prototype.$secretariaEditStatus = async (id,valor) => {
  try {
    let res = await axios.put('secretaria/a/editar/'+id, {
      status: valor
    });
    //console.log("aqui!"+ valor);
  } catch (e) {
    throw e;
  }
}

//editar assunto status
Vue.prototype.$assuntoEditStatus = async (id,valor) => {
  try {
    let res = await axios.put('assuntos/a/editar/'+id, {
      status: valor
    });
    //console.log("aqui!"+ valor);
  } catch (e) {
    throw e;
  }
}

//editar secretaria tudo
Vue.prototype.$secretariaEdit = async (id,row) => {
  try {
    let res = await axios.put('secretaria/a/editar/'+id, {
       exibir_ao_publico: row.publico,
       status: row.status,
       secretaria: row.nome,
    });
  } catch (e) {
    throw e;
  }
}

//editar assunto tudo
Vue.prototype.$assuntoEdit = async (id,row) => {
  try {
    let res = await axios.put('assuntos/a/editar/'+id, {
      status: row.status,
      assunto: row.nome
    });
    //console.log("aqui!"+ valor);
  } catch (e) {
    throw e;
  }
}

//cadastrar secretaria
Vue.prototype.$secretariaCadastrar = async (nome,publico,status) => {
  try {
    let res = await axios.post('secretaria/a/salvar', {
      exibir_ao_publico:publico,
      status: status,
      secretaria: nome,
    });
  } catch (e) {
    throw e;
  }
}

//cadastrar assunto
Vue.prototype.$assuntoCadastrar = async (nome,status) => {
  try {
    let res = await axios.post('assuntos/a/salvar', {
      status: status,
      assunto: nome,
    });
  } catch (e) {
    throw e;
  }
}

//deletar departamento
Vue.prototype.$deletarDepartamento = async (id) => {
  try {
    let res = await axios.delete('secretaria/a/delete/'+id, {});
  } catch (e) {
    throw e;
  }
}

//deletar assunto
Vue.prototype.$deletarAssunto = async (id) => {
  try {
    let res = await axios.delete('assuntos/a/delete/'+id, {});
  } catch (e) {
    throw e;
  }
}